import React from 'react';

const ClientLogo = ({ client }) => {
  return (
    <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex items-center justify-center">
      <img
        src={client.logo}
        alt={client.name}
        className="max-h-12 w-auto transition-all duration-300"
      />
    </div>
  );
};

export default ClientLogo;